<template>
  <div class="goods-slot-box" v-if="goods">
    <div class="goods" @click="onJumpToGoodsDetail">
      <div class="image">
        <image class="goods-img" :src="goods.mainImageUrl" />
      </div>
      <div class="content">
        <div class="goods-name">{{goods.title}}</div>
        <div class="price-box">
          <div class="left">
            <text class="goods-price">￥{{goods.price}}</text>
            <text class="mark-price">￥{{goods.markPrice}}</text>
          </div>
          <div v-if="goods.idType === 2" class="right">
            <div :class="['button', goods.stock === 0 ? 'no-stock' : '']">
              {{goods.stock > 0 ? '马上抢' : '已抢完'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navigateTo } from '@/views/activities/utils'
export default {
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      goods: undefined
    }
  },
  watch: {
    floor: {
      immediate: true,
      handler: 'init'
    }
  },
  methods: {
    init() {
      this.goods = this.floor.mixVO
    },
    onJumpToGoodsDetail() {
      navigateTo(this, {
        pageLinkType: 3,
        pageLinkValue: this.goods.idValue
      })
    }
  }
}
</script>

<style lang="less" scoped>
.goods {
  display: flex;
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
}
.goods .image,
.goods .goods-img {
  width: 240px;
  height: 240px;
}
.goods .image {
  position: relative;
}
.goods .content {
  flex: 1;
  box-sizing: border-box;
  padding: 35px 50px 35px 41px;
  font-size: 24px;
  position: relative;
}
.goods .goods-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 72px;
}
.goods .price-box {
  display: flex;
  align-items: center;
  position: absolute;
  left: 35px;
  right: 41px;
  bottom: 35px;
  z-index: 1;
}
.goods .price-box .left {
  flex: 1;
}
.goods .price-box .goods-price {
  color: #e83636;
}
.goods .price-box .mark-price {
  color: #ccc;
  text-decoration: line-through;
  margin-left: 10px;
}
.goods .price-box button {
  width: 100px;
  height: 42px;
  line-height: 42px;
  border-radius: 22px;
  font-size: 20px;
  background-color: #f8d541;
  color: #333;
  padding: 0;
}
.goods .price-box .no-stock {
  background-color: #f1f1f1;
  color: #ccc;
}

</style>
